import {
  Brand,
  BrandsListResponse
} from '@/modules/settings/brands/types/types.ts'

export const brandPage: { data: BrandsListResponse; message: string } = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        name: 'HP',
        isActive: true
      },
      {
        id: '7',
        name: 'ASUS',
        isActive: false
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 0
    }
  }
}

export const brandDetails: { data: Brand } = {
  data: {
    id: '1',
    name: 'hp',
    isActive: true
  }
}

export const brandCatalog = {
  data: [
    {
      id: '1',
      label: 'Xiaomi'
    },
    {
      id: '7',
      label: 'ASUS'
    },
    {
      id: '50',
      label: 'Suzuki'
    },
    {
      id: '60',
      label: 'Lenovo'
    },
    {
      id: '99',
      label: 'Mundo Grupo'
    },
    // Used by the marketplace products mocks
    {
      id: '100',
      label: 'Apple'
    },
    {
      id: '101',
      label: 'Samsung'
    },
    {
      id: '102',
      label: 'Anker'
    }
  ]
}

export const modelsCatalog = {
  data: [
    {
      id: '1',
      label: 'ZTE BLADE A56',
      maxCost: '97.30'
    },
    {
      id: '7',
      label: 'REDMI NOTE 12',
      maxCost: '177.10'
    }
  ]
}

export const modelPage = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        name: 'A2',
        description: null,
        isActive: true,
        nuovoIdentifier: '23026RN54G',
        maxCost: '88.55',
        brandName: 'XIAOMI',
        brandId: '83',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '2',
        name: 'ZTE BLADEA56',
        description: null,
        isActive: true,
        nuovoIdentifier: 'Z2473',
        maxCost: '97.30',
        brandName: 'ZTE',
        brandId: '15',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '3',
        name: 'REDMI NOTE 12',
        description: null,
        isActive: true,
        nuovoIdentifier: '23028RA60L',
        maxCost: '177.10',
        brandName: 'XIAOMI',
        brandId: '83',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '4',
        name: 'REDMI 12',
        description: null,
        isActive: true,
        nuovoIdentifier: '23053RN02L',
        maxCost: '88.55',
        brandName: 'XIAOMI',
        brandId: '83',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '5',
        name: '12',
        description: null,
        isActive: true,
        nuovoIdentifier: '23076RN8DY',
        maxCost: '132.83',
        brandName: 'XIAOMI',
        brandId: '83',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '6',
        name: 'NOTE 11 PRO 5G',
        description: null,
        isActive: true,
        nuovoIdentifier: '21091116UG',
        maxCost: '177.10',
        brandName: 'XIAOMI',
        brandId: '83',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '7',
        name: '11 LITE 5G',
        description: null,
        isActive: true,
        nuovoIdentifier: '2109119DG',
        maxCost: '132.83',
        brandName: 'XIAOMI',
        brandId: '83',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '8',
        name: 'HOT 20 5G',
        description: null,
        isActive: true,
        nuovoIdentifier: 'Infinix X666B',
        maxCost: '88.55',
        brandName: 'INFINIX',
        brandId: '3',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '9',
        name: 'HOT 30i',
        description: null,
        isActive: true,
        nuovoIdentifier: 'Infinix X669',
        maxCost: '240.86',
        brandName: 'INFINIX',
        brandId: '3',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '10',
        name: 'HOT 30 Play',
        description: null,
        isActive: true,
        nuovoIdentifier: 'Infinix X6835B',
        maxCost: '88.55',
        brandName: 'INFINIX',
        brandId: '3',
        supplierName: 'Nuovo',
        supplierId: '1'
      },
      {
        id: '11',
        name: 'NOTE 30 PRO',
        description: null,
        isActive: true,
        nuovoIdentifier: 'Infinix X678B',
        maxCost: '270.96',
        brandName: 'INFINIX',
        brandId: '3',
        supplierName: null,
        supplierId: null
      },
      {
        id: '12',
        name: 'G82',
        description: null,
        isActive: true,
        nuovoIdentifier: 'moto g82 5G',
        maxCost: '312.14',
        brandName: 'MOTOROLA',
        brandId: '4',
        supplierName: null,
        supplierId: null
      },
      {
        id: '13',
        name: 'E13',
        description: null,
        isActive: true,
        nuovoIdentifier: 'moto e13',
        maxCost: '88.55',
        brandName: 'MOTOROLA',
        brandId: '4',
        supplierName: null,
        supplierId: null
      },
      {
        id: '14',
        name: 'A24',
        description: null,
        isActive: true,
        nuovoIdentifier: 'SM-A245M',
        maxCost: '199.23',
        brandName: 'SAMSUNG',
        brandId: '5',
        supplierName: null,
        supplierId: null
      },
      {
        id: '15',
        name: 'A34',
        description: null,
        isActive: true,
        nuovoIdentifier: 'SM-A346M',
        maxCost: '425.04',
        brandName: 'SAMSUNG',
        brandId: '5',
        supplierName: null,
        supplierId: null
      },
      {
        id: '16',
        name: 'A33 5G',
        description: null,
        isActive: true,
        nuovoIdentifier: 'SM-A336M',
        maxCost: '225.81',
        brandName: 'SAMSUNG',
        brandId: '5',
        supplierName: null,
        supplierId: null
      },
      {
        id: '17',
        name: 'S20 FE',
        description: null,
        isActive: true,
        nuovoIdentifier: 'SM-G781U',
        maxCost: '442.75',
        brandName: 'SAMSUNG',
        brandId: '5',
        supplierName: null,
        supplierId: null
      },
      {
        id: '18',
        name: 'SAMSUNG S22 ULTRA',
        description: null,
        isActive: true,
        nuovoIdentifier: 'SM-S908U1',
        maxCost: '708.40',
        brandName: 'SAMSUNG',
        brandId: '5',
        supplierName: null,
        supplierId: null
      },
      {
        id: '19',
        name: 'TABLE 8',
        description: null,
        isActive: true,
        nuovoIdentifier: '3Q-3',
        maxCost: '98.00',
        brandName: 'Kids',
        brandId: '43',
        supplierName: null,
        supplierId: null
      },
      {
        id: '20',
        name: 'L5',
        description: null,
        isActive: true,
        nuovoIdentifier: '5033E',
        maxCost: '77.00',
        brandName: 'TCL',
        brandId: '30',
        supplierName: null,
        supplierId: null
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: true,
      prev: false,
      start: 1,
      end: 20,
      range: [1, 2, 3, 4, 5],
      count: 20,
      pages: 53,
      total: 1057,
      limit: 20
    }
  },
  status: 200
}

export const brandsByImeiSupplier = {
  data: [
    {
      id: 12,
      name: 'SAMSUNG',
      models: [
        { id: 340, name: 'GALAXY A54', supplier: { id: 5, name: 'NUOVO' } },
        { id: 341, name: 'GALAXY S24', supplier: { id: 5, name: 'NUOVO' } },
        { id: 342, name: 'GALAXY A54', supplier: { id: 1, name: 'MUNDO' } }
      ]
    },
    {
      id: 20,
      name: 'XIAOMI',
      models: [
        { id: 512, name: 'REDMI NOTE 13', supplier: { id: 1, name: 'MUNDO' } }
      ]
    }
  ]
}
